export default __webpack_public_path__ + "static/media/cabinet-logo-new.d89b3dc6.png";